/**
 * Created by PanJiaChen on 16/11/18.
 */

/**
 * @param {string} path
 * @returns {Boolean}
 */
export function isExternal(path) {
  return /^(https?:|mailto:|tel:)/.test(path)
}

/**
 * @param {string} str
 * @returns {Boolean}
 */
export function validUsername(str) {
  const valid_map = ['admin', 'editor']
  return valid_map.indexOf(str.trim()) >= 0
}
/**
 * 判断数据是否为空
 * @param {string} obj
 * @returns {Boolean}
 */
export function isEmpty(obj) {
  if (typeof obj == "undefined" || obj == null || obj == "" || obj == "null") {
    return true;
  } else {
    return false;
  }
}
/**
 * 默认返回yyyy-MM-dd HH-mm-ss
 * 可传第二个参数false，返回yyyy-MM-dd
 * 可传第三个参数，true 返回yyyy年MM月dd日
 * @param {*} str
 */
export function dateFormatter(str) {
  var hasTime = arguments[1] != false ? true : false;
  var hasType = arguments[2];
  var d = new Date(str);
  var year = d.getFullYear();
  var month = (d.getMonth() + 1) < 10 ? '0' + (d.getMonth() + 1) : (d.getMonth() + 1);
  var day = d.getDate() < 10 ? '0' + d.getDate() : d.getDate();
  var hour = d.getHours() < 10 ? '0' + d.getHours() : d.getHours();
  var minute = d.getMinutes() < 10 ? '0' + d.getMinutes() : d.getMinutes();
  var second = d.getSeconds() < 10 ? '0' + d.getSeconds() : d.getSeconds();
  if (hasTime) {
    if (hasType) {
      return `${month}月${day}日 ${hour}时${minute}分${second}秒`;
    }

    return [year, month, day].join('-') + " " + [hour, minute, second].join(':');

  } else {
    if (hasType) {
      return `${month}月${day}日`;
    }
    return [year, month, day].join('-');
  }
}
/**
 * 默认返回 [yyyy-MM-01,yyyy-MM-dd]   整月时间
 * @param {*} date
 * @param {Boolean} hasTime
 */
export function getTotalMonth(date, hasTime = false) {
  let newDate = new Date(date);
  let year = newDate.getFullYear();
  let month = newDate.getMonth() + 1 < 10 ? '0' + (newDate.getMonth() + 1) : newDate.getMonth() + 1;
  var hour = newDate.getHours() < 10 ? '0' + newDate.getHours() : newDate.getHours();
  var minute = newDate.getMinutes() < 10 ? '0' + newDate.getMinutes() : newDate.getMinutes();
  var second = newDate.getSeconds() < 10 ? '0' + newDate.getSeconds() : newDate.getSeconds();
  let timestamp = new Date(`${year}/${newDate.getMonth() + 2}/01`).getTime() - 24 * 60 * 60 * 1000;

  if (hasTime) {
    return [`${year}-${month}-01 ${hour}:${minute}:${second}`, dateFormatter(timestamp, true)];
  } else {
    return [`${year}-${month}-01`, dateFormatter(timestamp, false)];
  }

}
/**
 * 会诊主题
 * @param {*} value
 */
export function formatApplyTheme(value) {
  var applyTheme = value;
  switch (value) {
    case '0':
      applyTheme = '影像会诊';
      break;
    case '1':
      applyTheme = '临床会诊';
      break;
    case '2':
      applyTheme = '远程门诊';
      break;
    case '3':
      applyTheme = 'MDT会诊';
      break;
    case '4':
      applyTheme = '远程超声';
      break;
    case '5':
      applyTheme = '远程心电';
      break;
    case '6':
      applyTheme = '远程病理';
      break;
    case '7':
      applyTheme = '双向转诊';
      break;
    case '8':
      applyTheme = '远程培训';
      break;
    case '9':
      applyTheme = '国际会诊';
      break;
    default:
      break;
  }
  return applyTheme;
}
/**
 * 会诊主题路径名
 * @param {*} value
 */
export function formatApplyThemePathName(value) {
  var applyTheme = value;
  switch (value) {
    case '0':
      applyTheme = '远程影像申请';
      break;
    case '1':
      applyTheme = '临床会诊申请';
      break;
    case '2':
      applyTheme = '远程门诊申请';
      break;
    case '3':
      applyTheme = 'mdt会诊申请';
      break;
    case '4':
      applyTheme = '远程超声申请';
      break;
    case '5':
      applyTheme = '远程心电申请';
      break;
    case '6':
      applyTheme = '远程病理申请';
      break;
    case '7':
      applyTheme = '双向转诊';
      break;
    case '8':
      applyTheme = '远程培训';
      break;
    case '9':
      applyTheme = '国际会诊';
      break;
    default:
      break;
  }
  return applyTheme;
}
// /**
//  * 会诊主题 反获取
//  * @param {*} value
//  */
export function formatApplyThemeReverse(value) {
  var applyTheme = value;
  switch (value) {
    case '远程影像申请':
      applyTheme = '0';
      break;
    case '临床会诊申请':
      applyTheme = '1';
      break;
    case '远程门诊申请':
      applyTheme = '2';
      break;
    case 'mdt会诊申请':
      applyTheme = '3';
      break;
    case '远程超声申请':
      applyTheme = '4';
      break;
    case '远程心电申请':
      applyTheme = '5';
      break;
    case '远程病理申请':
      applyTheme = '6';
      break;
    case '双向转诊':
      applyTheme = '7';
      break;
    case '远程培训':
      applyTheme = '8';
      break;
    case '国际会诊':
      applyTheme = '9';
      break;
    default:
      break;
  }
  return applyTheme;
}


/**
 * 会诊方式
 * @param {*} value
 */
export function formatConsultationMethod(value) {
  var consultationMethod = value;
  switch (value) {
    case '0':
      consultationMethod = '非指名会诊';
      break;
    case '1':
      consultationMethod = '指名会诊';
      break;
    default:
      break;
  }
  return consultationMethod;
}
/**
 * 预约会诊
 * @param {*} value
 */
// export function formatAppointmentType(value) {
//   var appointmentType = value;
//   switch (value) {
//     case '0':
//       appointmentType = '非预约';
//       break;
//     case '1':
//       appointmentType = '预约';
//       break;
//     default:
//       break;
//   }
//   return appointmentType;
// }
/**
 * 会诊类型
 * @param {*} value
 */
export function formatConsultationType(value) {
  var consultationType = value;
  switch (value) {
    case '0':
      consultationType = '交互式';
      break;
    case '1':
      consultationType = '普通';
      break;
    case '2':
      consultationType = '急诊';
      break;
    default:
      break;
  }
  return consultationType;
}
/**
 * 会诊类型
 * @param {*} value
 */
export function formatAppointmentType(value) {
  var appointmentType = value;
  switch (value) {
    case 0:
      appointmentType = '交互式';
      break;
    case 1:
      appointmentType = '离线式';
      break;
    // case '2':
    //   consultationType = '急诊';
    //   break;
    default:
      break;
  }
  return appointmentType;
}

/**
 * 组状态
 * 0:未激活,1:激活，2:禁用
 */
export function formatTeamStatus(value){
  var stauts = value;
  switch(value){
    case 0:
      stauts = '未激活';
      break;
    case 1:
      stauts = '激活';
      break;
    case 2:
      stauts = '禁用';
      break;
    default:
      break;
  }
  return stauts;
}
/**
 * hh:mm
 */
// export function frtTime(val){
//   if(val)
//     return val.slice(11,-3)
//   return
// }

/**
 * 会诊状态
 * @param {*} value
 */
export function formatStatus(value) {
  var status = value;
  switch (value) {
    case 0:
      status = '暂存';
      break;
    case 1:
      status = '未叫号';
      break;
    case 2:
      status = '已叫号';
      break;
    case 3:
      status = '延号';
      break;
    case 4:
      status = '弃号';
      break;
    case 5:
      status = '已准备';
      break;
    case 6:
      status = '会诊中';
      break;
    case 7:
      status = '已完成';
      break;
    case -1:
      status = '删除';
      break;
    default:
      break;
  }
  return status;
}

/**
 * 号别类型
 * @param {*} value
 */
export function formatNumType(value) {
  var numType = value;
  switch (value) {
    case 0:
      numType = '普通号';
      break;
    case 1:
      numType = '专家号';
      break;
    // case '2':
    //   consultationType = '急诊';
    //   break;
    default:
      break;
  }
  return numType;
}


/**
 * 申请类型
 * @param {*} value
 */
export function formatApplyType(value) {
  var applyType = value;
  switch (value) {
    case '0':
      applyType = '初诊';
      break;
    case '1':
      applyType = '复诊';
      break;
    default:
      break;
  }
  return applyType;
}
/**
 * 申请状态
 * @param {*} value
 */
export function formatApplyStatus(value) {
  var applyStatus = value;
  switch (value) {
    case '0':
      applyStatus = '待申请';
      break;
    case '1':
      applyStatus = '待前质控';
      break;
    case '2':
      applyStatus = '待分诊';
      break;
    case '3':
      applyStatus = '待接诊';
      break;
    case '4':
      applyStatus = '待报告';
      break;
    case '5':
      applyStatus = '待后质控';
      break;
    case '6':
      applyStatus = '待采纳';
      break;
    case '7':
      applyStatus = '未评价';
      break;
    case '8':
      applyStatus = '完成';
      break;
    case '9':
      applyStatus = '取消';
      break;
    default:
      break;
  }
  return applyStatus;
}
/**
 * 身份证号校验
 * @param {string} value
 * @returns {Boolean}
 */
export function isIdCard(value) {
  return /(^\d{18}$)|(^\d{17}(\d|X|x)$)/.test(value) || /[0]{18}/.test(value)
}
/**
 * 电话好号码（手机号及固定电话）验证
 * @param {string} value
 * @returns {Boolean}
 */
export function isPhone(value) {
  return /^1(3|4|5|6|7|8|9)\d{9}$/.test(value) || /^(\(\d{3,4}\)|\d{3,4}-|\s)?\d{7,14}$/.test(value)
}
export function isMobile(value) {
  return /^1(3|4|5|6|7|8|9)\d{9}$/.test(value) || /[0]{11}/.test(value)
}

export function imgReg(file) {
  return /\.(png|jpg|gif|jpeg)$/.test(file)
}

/**
 * 密码验证
 * @param {*} val
 * @returns
 */
 export function pwdReg(val) {
  return /^(?=.*[a-z])(?=.*[A-Z])(?=.*[$@$!%*?&#^\(\)~])[A-Za-z\d$@$!%*?&#^\(\)~]{6,}/.test(val)
}

/**
 * 密码正则生成
 * @param {*} data 密码正则数据
    * @param {*} 'requireUppercase': true, // 要求大写字母
    * @param {*} 'requireLowercase': true, // 要求小写字母
    * @param {*} 'requireDigit': true, // 要求数字
    * @param {*} 'requireNonAlphanumeric': true, // 要求非字母数字
 * @param {*} minLen 最小长度
 * @returns 返回正则
 */
export function passwordRegSet(minLen = 8, data) {
  let { requireUppercase, requireLowercase, requireDigit, requireNonAlphanumeric } = data
  let reg = ''
  let rega = '[A-Za-z0-9\\W_!@#$%^&*`~\(\)-+=]'
  if (requireUppercase) {
    reg += '(?=.*[A-Z])'
  }
  if (requireLowercase) {
    reg += '(?=.*[a-z])'
  }
  if (requireDigit) {
    reg += '(?=.*[0-9])'
  }
  if (requireNonAlphanumeric) {
    reg += '(?=.*[\\W_!@#$%^&*`~\(\)-+=])'
  }
  return reg ? new RegExp(`^${reg}${rega}{${minLen},}$`) : ''
}

//判断上传的路径是不是绝对路径 / /如果是绝对路径则返回空字符串
export function isValidUrl(url) {
    if(url === '/'){//绝对路径
        return ''
    }
    return url
}


// WEBPACK FOOTER //
// ./src/utils/validate.js